import axios from 'axios';

export default {
  namespaced: true,
  state: {
    showIframe: false,
    signatureSaved: false
  },
  mutations: {
    setPrescriberChatIframe(state, payload) {
      window.localStorage.setItem('showIframe', payload);
      state.showIframe = payload;
    },
    setSignatureSaved(state, payload) {
      state.signatureSaved = payload;
    }
  },
  actions: {
    fetchChatStatusMessage({ state, commit }) {
      return axios.get('Chat/GetChatConfiguration')
        .catch(error => {
          if (error.response && error.response.status === 404) {
            // If chat service is unavailable (404), set chat status to false
            commit('navigation/setChatStatus', false, { root: true });
            return { data: { isChatAvailable: false, chatStatusMessage: 'Chat is momenteel niet beschikbaar.' } };
          }
          throw error;
        });
    }
  },
  getters: {
    getPrescriberChatIframe: (state) => {
      if (window.localStorage.getItem('showIframe') === 'true') {
        state.showIframe = true;
      }
      return state.showIframe;
    },
    getSignatureSaved: (state) => {
      return state.signatureSaved;
    }
  }
};
